import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  SectionBaseWrapper
} from './styled'

export class SectionBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      scroll,
      scrollOverlay,
      nonFluid,
      // Default
      flex,
      direction,
      justify,
      align,
      top,
      left,
      right,
      bottom,
      width,
      maxWidth,
      widthUnit,
      height,
      minHeight,
      calcHeight,
      calcMinHeight,
      calcMinWidth,
      heightUnit,
      padding,
      paddingTop,
      paddingRight,
      paddingBottom,
      paddingLeft,
      paddingHorizontal,
      paddingVertical,
      spacing,
      spacingTop,
      spacingRight,
      spacingBottom,
      spacingLeft,
      spacingHorizontal,
      spacingVertical,
      bgColor,
      borderTopWidth,
      borderTopStyle,
      borderTopColor,
      borderRightWidth,
      borderRightStyle,
      borderRightColor,
      borderBottomWidth,
      borderBottomStyle,
      borderBottomColor,
      borderLeftWidth,
      borderLeftStyle,
      borderLeftColor,
      textAlign,
      display,
      onClick,
      positionTop,
      positionLeft,
      transform,
      borderRadius,
    } = this.props

    return (
      <SectionBaseWrapper
        className={ClassNames(
          'section-base',
          { 'is-scroll': scroll },
          { 'is-scroll-overlay': scrollOverlay },
          { 'is-non-fluid': nonFluid },
          // Option
          className
        )}
        theme={{
          // Default
          flex,
          direction,
          justify,
          align,
          top,
          left,
          right,
          bottom,
          width,
          maxWidth,
          widthUnit,
          height,
          minHeight,
          calcHeight,
          calcMinHeight,
          calcMinWidth,
          heightUnit,
          padding,
          paddingTop,
          paddingRight,
          paddingBottom,
          paddingLeft,
          paddingHorizontal,
          paddingVertical,
          spacing,
          spacingTop,
          spacingRight,
          spacingBottom,
          spacingLeft,
          spacingHorizontal,
          spacingVertical,
          bgColor,
          borderTopWidth,
          borderTopStyle,
          borderTopColor,
          borderRightWidth,
          borderRightStyle,
          borderRightColor,
          borderBottomWidth,
          borderBottomStyle,
          borderBottomColor,
          borderLeftWidth,
          borderLeftStyle,
          borderLeftColor,
          textAlign,
          display,
          positionTop,
          positionLeft,
          transform,
          borderRadius,
        }}
        onClick={onClick}
      >
        {children}
      </SectionBaseWrapper>
    )
  }

  static defaultProps = {
    widthUnit: 'px',
    heightUnit: 'px'
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string,
    scroll: PropTypes.bool,
    scrollOverlay: PropTypes.bool,
    nonFluid: PropTypes.bool,

    flex: PropTypes.string,
    direction: PropTypes.string,
    justify: PropTypes.string,
    align: PropTypes.string,
    top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    right: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    bottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    widthUnit: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    calcHeight: PropTypes.string,
    calcMinHeight: PropTypes.string,
    calcMinWidth: PropTypes.string,
    heightUnit: PropTypes.string,
    padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingRight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingBottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingHorizontal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingVertical: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    spacing: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    spacingTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    spacingRight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    spacingBottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    spacingLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    spacingHorizontal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    spacingVertical: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    bgColor: PropTypes.string,
    borderTopWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderTopStyle: PropTypes.string,
    borderTopColor: PropTypes.string,
    borderRightWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderRightStyle: PropTypes.string,
    borderRightColor: PropTypes.string,
    borderBottomWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderBottomStyle: PropTypes.string,
    borderBottomColor: PropTypes.string,
    borderLeftWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderLeftStyle: PropTypes.string,
    borderLeftColor: PropTypes.string,
    textAlign: PropTypes.string,
    display: PropTypes.string,
    onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    positionTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    positionLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    transform: PropTypes.string,

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}
